export const cleanObject = <T>(object: T): Partial<T> => {
  const cleanedObject: any = {}
  Object.entries(object).forEach(([key, value]) => {
    if (!(typeof value === 'undefined' || value === '')) {
      cleanedObject[key] = value
    }
  })
  return cleanedObject
}
